
import { Vue, Component, Prop } from "vue-property-decorator"

import TransportDocumentDetail from "@/graphql/transportdocument/transportdocumentdetail.graphql"
import TransportDocumentEdit from "./TransportDocumentEdit.vue"
import { CircularLoader } from "@coredination/components"
import TransportDocumentView from "./TransportDocumentView.vue"

@Component({
    apollo: {
        transportDocument: {
            query: TransportDocumentDetail,
            skip() {
                return !this.uuid
            },
            variables() {
                return { uuid: this.uuid }
            },
            update(data: any) {
                this.component = "TransportDocumentEdit"
                if (data?.transportDocument?.state === "COMPLETE")
                    this.component = "TransportDocumentView"
                return data.transportDocument
            }
        }
    },
    components: {
        TransportDocumentEdit,
        TransportDocumentView,
        CircularLoader
    },
})
export default class TransportDocumentRouteLanding extends Vue {
    @Prop({ default: null })
    uuid!: string
    
    transportDocument: any
    component?: null | string = null

    get loading() {
        return this.$apollo.queries.transportDocument.loading
    }
}
